<template>
  <component
    :is="component" :to="to" :href="href" :type="type"
    class="font-medium leading-tight inline-flex items-center justify-start text-left cursor-pointer appearance-none duration-100 relative"
    :class="getStyle(styles, 'container')"
    :style="theme?.base ? {
      textDecorationColor: theme.base.background.accent
    } : {}"
    v-bind="{
      ...(download ? { download } : {}),
    }"
  >
    <IconBase name="cute/spinner-fill" class="spin mr-1.5 inline-block -my-0.5" :width="14" v-if="isLoading" />

    <slot />

    <span class="absolute block bottom-[4%] -left-[1px] -right-[1px] rounded-md h-[30%] opacity-10 dark:opacity-30" :style="{ background: 'currentColor' }" />
  </component>
</template>

<script lang="ts" setup>
import { defineStyles, getStyle } from '@/utils/useStyles'
import { Theme } from '@/classes'

const props = withDefaults(defineProps<{
  size?: 'xs' | 'sm' | 'base' | 'md'
  color?: 'slate' | 'white' | ''
  theme?: Theme | null
  to?: RouteLocationRaw
  href?: string
  download?: string
  isInvert?: boolean
  isDotted?: boolean
  isLoading?: boolean
  isDisabled?: boolean
  type?: string
}>(), {
  size: 'base',
  color: 'slate',
  theme: null,
  download: '',
  to: undefined,
  href: undefined,
  isLoading: false,
  isInvert: false,
  isDotted: false,
  isDisabled: false,
  type: 'button'
})

const component = computed(() => {
  if (props.href) return 'a'
  if (props.to) return resolveComponent('NuxtLink')

  return 'button'
})

const styles = computed(() => defineStyles({
  container: {
    isDotted: ['decoration-dotted', ''],
    isDisabled: ['opacity-50 pointer-events-none', ''],
    size: {
      xs: 'text-xs underline-offset-[4px]',
      sm: 'text-sm underline-offset-[5px]',
      base: 'text-base underline-offset-[6px]',
      md: 'text-md underline-offset-[6px]',
    },
    color: {
      slate: props.isInvert ? ['hover:decoration-charcoal-950/100 decoration-charcoal-950/0 dark:decoration-white/20'] : ['decoration-charcoal-950/20 hover:decoration-charcoal-950 dark:decoration-white/20'],
      white: props.isInvert ? ['hover:decoration-white/100 decoration-white/0 dark:decoration-white/20'] : ['decoration-white/20 hover:decoration-white dark:decoration-white/20']
    }
  }
}, props))
</script>